"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4532],{

/***/ 3977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G7": function() { return /* binding */ getContentFooterImageId; },
  "J1": function() { return /* binding */ getContentTags; },
  "Bu": function() { return /* binding */ getGeneralInformation; },
  "d": function() { return /* binding */ getHomeTopPageData; },
  "vf": function() { return /* binding */ getMenuItems; },
  "gu": function() { return /* binding */ getMilestones; },
  "Jq": function() { return /* binding */ getPosts; },
  "fu": function() { return /* binding */ getSupportPosts; },
  "cj": function() { return /* binding */ postBobbyApplication; },
  "w": function() { return /* binding */ postComment; },
  "QL": function() { return /* binding */ postLetterSubscription; },
  "sX": function() { return /* binding */ postVolunteerApplication; }
});

// UNUSED EXPORTS: getAssignmentDetail, getAudioDetail, getFaqOverviewData, getFaqs, getHomeData, getMilestonesPageData, getOpenLetter, getPostDetail, getTrainingDays, getVolunteerRegisterPageData

// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./constants/endpoints.ts
const BASE_ENDPOINT = "https://admin.villapinedo.nl";
const endpoints_ENDPOINTS = {
    BASE: BASE_ENDPOINT,
    COLLECTIONS: "".concat(BASE_ENDPOINT, "/items"),
    FILES: "".concat(BASE_ENDPOINT, "/assets"),
    GRAPHQL: "".concat(BASE_ENDPOINT, "/graphql"),
    GRAPHQL_SYSTEM: "".concat(BASE_ENDPOINT, "/system/graphql")
};
// todo: delete ENDPOINTS once everything is working against the new CMS
// URLS is replacing ENDPOINTS
/* harmony default export */ var endpoints = (endpoints_ENDPOINTS);

// EXTERNAL MODULE: ./constants/urls.ts
var urls = __webpack_require__(26854);
;// CONCATENATED MODULE: ./api/api.ts



/**
 * Add a comment
 * @param type "forum" or "blog"
 * @param data
 */ const postComment = async (type, param)=>{
    let { post_id , ...rest } = param;
    await fetch("".concat(urls/* default.APP */.Z.APP, "/comment"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...rest,
            content: browser_default().sanitize(rest.content),
            ["".concat(type.includes("letter") ? type : "".concat(type, "_post"))]: post_id,
            status: "draft",
            entityType: type
        })
    });
};
/**
 * Get all the menu items used for navigation
 * @returns array or null
 */ const getMenuItems = async ()=>{
    try {
        const res = await fetch("".concat(urls/* default.APP */.Z.APP, "/menu-items"), {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        const resData = await res.json();
        return resData;
    } catch (error) {
        return null;
    }
};
/**
 * Get the general information of the website
 * @returns GeneralInformationTypes or null (if error)
 */ const getGeneralInformation = async ()=>{
    try {
        const response = await fetch("".concat(urls/* default.APP */.Z.APP, "/general-information"), {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        return await response.json();
    } catch (error) {
        return null;
    }
};
/**
 * get the top home page details
 *
 */ const getHomeTopPageData = async (param)=>{
    let { ageCategory , category , page  } = param;
    let url = "".concat(urls/* default.APP */.Z.APP, "/homepage/home-top-data-without-email?BlogPostCount=1&ForumCount=1&InstagramCount=1&ChatItemCount=1&AudioItemCount=1&VideoItemCount=1&AssignmentCount=1&OpenLetterCount=1");
    if (ageCategory) {
        url = "".concat(url, "&ageCategory=").concat(ageCategory);
    }
    if (category) {
        url = "".concat(url, "&category=").concat(category);
    }
    if (page) {
        url = "".concat(url, "&page=").concat(page);
    }
    return await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Get the assignment items
 */ const getAssignmentDetail = async (slug)=>{
    const response = await fetch("".concat(URLS.APP, "/assignments?slug=").concat(slug), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const result = await response.json();
    return result === null || result === void 0 ? void 0 : result[0];
};
/**
 * Add a letter subscription
 * @param data
 */ const postLetterSubscription = async (data)=>{
    await fetch("".concat(endpoints.COLLECTIONS, "/letter_submissions"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
};
const getSupportPosts = async (param)=>{
    let { typeContent , sort , search , category , postPerPage , page  } = param;
    let url = "".concat(urls/* default.APP */.Z.APP, "/support-overview-page/entities");
    let prepend = "?";
    if (postPerPage) {
        url = "".concat(url).concat(prepend, "maxresultcount=").concat(postPerPage);
        prepend = "&";
    }
    if (page) {
        url = "".concat(url).concat(prepend, "page=").concat(page);
    }
    if (search) {
        url = "".concat(url).concat(prepend, "search=").concat(search);
    }
    if (category) {
        url = "".concat(url).concat(prepend, "category=").concat(category);
    }
    if (sort) {
        url = "".concat(url).concat(prepend, "sort=").concat(sort);
    }
    if (typeContent) {
        url = "".concat(url).concat(prepend, "typeContent=").concat(typeContent);
    }
    return await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Gets a list of blog posts
 * @param postPerPage the amount of posts to be shown per page
 * @param page the current paginated page
 * @returns
 */ const getPosts = async (param)=>{
    let { sort , filter , page , search , category , signal  } = param;
    let url = "".concat(urls/* default.APP */.Z.APP, "/blog-posts");
    let prepend = "?";
    if (page) {
        url = "".concat(url).concat(prepend, "page=").concat(page);
        prepend = "&";
    }
    if (search) {
        url = "".concat(url).concat(prepend, "search=").concat(search);
    }
    if (sort) {
        url = "".concat(url, "&sort=").concat(sort);
    }
    if (filter) {
        url = "".concat(url, "&").concat(filter);
    }
    if (category) {
        url = "".concat(url, "&category=").concat(category);
    }
    return await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        },
        signal
    });
};
/*get a list of tips */ /**
 * Get the post detail base on the slug
 * @param slug the post slug
 * @returns
 */ const getPostDetail = async (slug)=>{
    var _result_data;
    const response = await fetch("".concat(URLS.APP, "/blog-posts?slug=").concat(slug), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const result = await response.json();
    return result === null || result === void 0 ? void 0 : (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data[0];
};
/**
 * Get the audio detail base on the slug
 * @param slug the post slug
 * @returns
 */ const getAudioDetail = async (slug)=>{
    const response = await fetch("".concat(URLS.APP, "/audio-items?slug=").concat(slug), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const result = await response.json();
    return result === null || result === void 0 ? void 0 : result[0];
};
/**
 * Gets the data for the homepage
 * @returns
 */ const getHomeData = async function() {
    let isForAdults = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const searchParams = new URLSearchParams({
        isForAdults: isForAdults.toString()
    });
    return await fetch("".concat(URLS.APP, "/homepage?").concat(searchParams), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Add a volunteer application
 * @param data
 */ const postVolunteerApplication = async (data)=>{
    await fetch("".concat(urls/* default.APP */.Z.APP, "/volunteer-registration-form"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...data
        })
    });
};
const postBobbyApplication = async (data)=>{
    return fetch("".concat(urls/* default.APP */.Z.APP, "/kid-registration"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...data,
            // Set the birthdate to a string in YYYY-MM-DD format
            birthdate: new Date(data.birthdate).toISOString().split("T")[0]
        })
    });
};
/**
 * Gets all available tags
 */ const getContentTags = async ()=>{
    let url = "".concat(urls/* default.APP */.Z.APP, "/theme?MaxResultCount=999&status=1");
    return await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Gets a list of faq items
 * @param postPerPage the amount of items to be shown per page
 * @returns
 */ const getFaqs = async (param)=>{
    let { // postPerPage,
    // page = 1,
    search , sort , filter , meta ="total_count" , type ="volunteer_faq"  } = param;
    let url = "".concat(ENDPOINTS.COLLECTIONS, "/faq_items?fields=*.*.*?filter[status][_eq]=published&filter[type][_eq]=").concat(type);
    if (meta) {
        url = "".concat(url, "&meta=").concat(meta);
    }
    if (search) {
        url = "".concat(url, "&search=").concat(search);
    }
    if (sort) {
        url = "".concat(url, "&sort=").concat(sort);
    }
    if (filter) {
        url = "".concat(url, "&").concat(filter);
    }
    return await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Gets the data for the faq overview page
 * @returns
 */ const getFaqOverviewData = async ()=>{
    return await fetch("".concat(ENDPOINTS.COLLECTIONS, "/faq_overview_page?fields=*.*"), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
};
/**
 * Get the page data for the milestones page.
 *
 * @returns MilestonesPageData
 */ const getMilestonesPageData = async ()=>{
    const response = await fetch("".concat(URLS.APP, "/milestones-page"), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const data = await response.json();
    return data;
};
/**
 * Get all the milestones
 *
 * @returns MilestoneType[]
 */ const getMilestones = async (skipCount, maxResultCount)=>{
    const response = await fetch("".concat(urls/* default.APP */.Z.APP, "/milestone?SkipCount=").concat(skipCount, "&MaxResultCount=").concat(maxResultCount, "&Sorting=order"), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    return await response.json();
};
const getContentFooterImageId = async ()=>{
    const req = getGeneralInformation();
    return req.then((res)=>{
        return res === null || res === void 0 ? void 0 : res.contentFooterImageId;
    });
};
/**
 * Get an open letter by slug.
 * @param slug
 * @returns Promise<any> - The open letter data
 */ const getOpenLetter = async (slug)=>{
    const response = await fetch("".concat(URLS.APP, "/open-letter/by-slug?slug=").concat(slug), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    return await response.json();
};
/**
 * Get the page data for the volunteer register page.
 *
 * @returns Promise<any> - The page data
 */ const getVolunteerRegisterPageData = async ()=>{
    const response = await fetch("".concat(URLS.APP, "/volunteer-register"), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    return await response.json();
};
/**
 * Get the volunteer training days.
 *
 * @returns Promise<any> - The training days
 */ const getTrainingDays = async ()=>{
    const response = await fetch("".concat(URLS.APP, "/volunteer-training-day/volunteer-training-days"), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    return await response.json();
};


/***/ }),

/***/ 46896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52091);
/* harmony import */ var _components_buttons_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78084);




const BackToTopButton = ()=>{
    const [isVisible, setIsVisible] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    // Function to scroll to the top of the page
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    // Show the button when the user has scrolled down a certain distance
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleScroll = ()=>{
            if (window.scrollY > 100) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: isVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_buttons_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "bg-pink fixed right-6 bottom-[70px] z-50 cursor-pointer rounded-full border-none transition duration-300 ease-in-out hover:scale-110",
            Icon: react_icons_fa__WEBPACK_IMPORTED_MODULE_3__/* .FaChevronUp */ .s$2,
            iconColor: "var(--color-white)",
            wrapperSize: 44,
            iconSize: 28,
            onClick: scrollToTop
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BackToTopButton);


/***/ }),

/***/ 78084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50066);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: white;\n  width: 90px;\n  height: 90px;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d1927b1d-0"
})(_templateObject());
function IconButton(param) {
    let { Icon , iconColor ="black" , iconSize =32 , wrapperSize =90 , wrapperColor ="white" , className ="" , onClick , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
        style: {
            height: wrapperSize,
            width: wrapperSize,
            backgroundColor: wrapperColor
        },
        onClick: onClick,
        className: className,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Icon, {
            color: iconColor,
            size: iconSize
        })
    });
}


/***/ }),

/***/ 26854:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const BASE_URL = "https://abp.villapinedo.nl";
const URLS = {
    BASE: BASE_URL,
    CMSKIT: "".concat(BASE_URL, "/api/cms-kit"),
    FILE: "".concat(BASE_URL, "/api/file"),
    APP: "".concat(BASE_URL, "/api/app"),
    ADULTS: "https://volwassenen.villapinedo.nl",
    PAGES: {
        OPEN_LETTERS_PARENTS: "/open-brieven-ouders",
        MEDIA_REPORTS: "/mediaberichten",
        MEDIA_REPORTS_DETAIL: "/in-de-media",
        VACANCIES: "/vacatures",
        SPONSOR_BUDDY_FORM: "/sponsor-een-buddy/buddy-sponsoren-aanmelden",
        TIPS: "/tips",
        STORIES: "/verhalen",
        INFORMATION: "/informatie",
        FORUM_PARENTS: "/forum_ouders",
        FORUM_CHILDREN: "/forum",
        ASK_A_QUESTION_CHILDREN: "/stel-een-vraag",
        ASK_A_QUESTION_PARENTS: "/stel-een-vraag-ouders"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (URLS);


/***/ }),

/***/ 15223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ BlogTypeValues; }
/* harmony export */ });
var BlogTypeValues;
(function(BlogTypeValues) {
    BlogTypeValues["Blog"] = "Blog";
    BlogTypeValues["Vlog"] = "Vlog";
    BlogTypeValues["Tip"] = "Tip";
    BlogTypeValues["Information"] = "Information";
})(BlogTypeValues || (BlogTypeValues = {}));


/***/ }),

/***/ 24758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CN": function() { return /* binding */ formatUrl; },
/* harmony export */   "FS": function() { return /* binding */ isInternalLink; },
/* harmony export */   "Qx": function() { return /* binding */ decodeTagFromUrl; },
/* harmony export */   "SV": function() { return /* binding */ getBaseUrl; },
/* harmony export */   "a6": function() { return /* binding */ determineTargetAttribute; },
/* harmony export */   "jb": function() { return /* binding */ getPathFromUrl; },
/* harmony export */   "kQ": function() { return /* binding */ getContentPath; },
/* harmony export */   "vy": function() { return /* binding */ encodeTagForURL; }
/* harmony export */ });
/* unused harmony exports slugify, validateAndRedirectSlugWithThemes, isProduction */
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34155);
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(process__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _api_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3977);
/* harmony import */ var _enums_blogTypeValues__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15223);



/**
 * Takes an URL String and removes query params and hash params
 *
 * @param url - The URL string
 * @returns The transformed URL string
 *
 */ const getPathFromUrl = (url)=>{
    return url.split(/[?#]/)[0];
};
/**
 * Detects if a given url leads to an internal path or not
 * @param url
 */ const isInternalLink = (url)=>{
    // regex to check to check full urls and urls like //ajax.googleapis.com/
    const internalUrlRegex = /^\/\/|^\/(?!\/)/;
    return internalUrlRegex.test(url);
};
/**
 * Transforms a string into a slug
 * @param str string
 * @returns string
 */ const slugify = (str)=>{
    return str.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
};
/**
 * Encode url for tags by:
 * - Lowercasing the tag
 * - Replacing spaces with hyphens
 * - Encoding the string
 *
 * @param tag
 * @returns string with encoded url
 */ const encodeTagForURL = (tag)=>{
    return encodeURIComponent(tag.toLowerCase().replace(/\s/g, "-"));
};
/**
 * Decode tag from url by:
 * - Lowercasing the tag
 * - Replacing hyphens with spaces
 * - Decoding the string
 *
 * @param tag
 * @returns string with decoded url
 */ const decodeTagFromUrl = (tag)=>{
    return decodeURIComponent(tag.toLowerCase().replace(/-/g, " "));
};
/**
 * Retrieves the categories from a slug.
 * @param slug - The slug string or array of slug strings.
 * @returns An array of decoded category tags.
 */ const getCategoriesFromSlug = (slug)=>{
    return Array.isArray(slug) ? slug.slice(0, -1).map(decodeTagFromUrl) : [
        decodeTagFromUrl(slug[0])
    ];
};
/**
 * Retrieves the lowercase names of the categories associated with a content item.
 * @param contentItem - The content item object.
 * @returns An array of lowercase category names.
 */ const getContentItemCategories = (contentItem)=>{
    return (contentItem.categories || contentItem.themes).map((category)=>category.name.toLowerCase());
};
/**
 * Encodes and joins an array of categories into a URL path.
 *
 * @param categories - An array of categories to encode and join.
 * @returns The encoded and joined URL path.
 */ const encodeAndJoinCategories = (categories)=>{
    return categories.map(encodeTagForURL).join("/");
};
/**
 * Checks if every category in the slug is valid.
 *
 * @param categoriesInSlug - An array of categories in the slug.
 * @param categories - An array of all available categories.
 * @returns A boolean indicating if every category in the slug is valid.
 */ const isEverySlugCategoryValid = (categoriesInSlug, categories)=>{
    return categoriesInSlug.every((category)=>categories.some((tag)=>tag.name.toLowerCase() === category));
};
/**
 * Checks if every slug category is present in the content item categories.
 *
 * @param categoriesInSlug - An array of slug categories.
 * @param contentItemCategories - An array of content item categories.
 * @returns A boolean indicating whether every slug category is present in the content item categories.
 */ const isEverySlugCategoryInContentItemCategories = (categoriesInSlug, contentItemCategories)=>{
    return categoriesInSlug.every((category)=>contentItemCategories.includes(category));
};
/**
 * Validate if the url contains the themes in the correct order and redirect if
 * not. If the url is correct, return the server side props.
 *
 * @param ctx - GetServerSidePropsContext object, provided by getServerSideProps
 * @param getContent - Function to get the content that should be returned in the props
 * @param getContentItem - Function to get content item by the slug
 * @param contentUrlPrefix - Prefix of the content url (e.g. "/verhalen")
 */ const validateAndRedirectSlugWithThemes = async (ctx, getContent, getContentItem, contentUrlPrefix)=>{
    let slug = Array.isArray(ctx.query.slug) ? ctx.query.slug : [
        ctx.query.slug
    ];
    const contentSlug = slug.slice(-1)[0];
    const contentItem = await getContentItem(contentSlug);
    if (!contentItem) return {
        notFound: true
    };
    const contentItemCategories = getContentItemCategories(contentItem);
    // If the content item has no categories
    if (contentItemCategories.length === 0) {
        // Redirect to 404 if the slug has more than one item (i.e. categories)
        if (slug.length > 1) return {
            notFound: true
        };
        // Return the content if only the slug is provided
        return {
            props: {
                ...await getContent(contentItem)
            }
        };
    }
    const contentItemCategoriesUrl = encodeAndJoinCategories(contentItemCategories);
    // Redirect to the URL with the correct categories if only the contentItem slug is provided
    if (slug.length === 1 || slug[0] === contentSlug) {
        return {
            redirect: {
                destination: "".concat(contentUrlPrefix, "/").concat(contentItemCategoriesUrl, "/").concat(contentSlug)
            }
        };
    }
    const categoriesInSlug = getCategoriesFromSlug(slug);
    const allCategories = (await (await getContentTags()).json()).items;
    const everySlugCategoryIsValidCategory = isEverySlugCategoryValid(categoriesInSlug, allCategories);
    const everySlugCategoryIsInContentItemCategories = isEverySlugCategoryInContentItemCategories(categoriesInSlug, contentItemCategories);
    // Redirect to 404 if there are categories in the URL that don't exist or are not in the contentItem
    if (!everySlugCategoryIsValidCategory || !everySlugCategoryIsInContentItemCategories) {
        return {
            notFound: true
        };
    }
    const slugCategoriesUrl = encodeAndJoinCategories(categoriesInSlug);
    // Fix the URL if the categories in the URL are not in the correct order
    if (contentItemCategoriesUrl !== slugCategoriesUrl) {
        return {
            redirect: {
                destination: "".concat(contentUrlPrefix, "/").concat(contentItemCategoriesUrl, "/").concat(contentSlug)
            }
        };
    }
    return {
        props: {
            ...await getContent(contentItem)
        }
    };
};
const formatUrl = (url)=>{
    return url.startsWith("http://") || url.startsWith("https://") ? url : "http://".concat(url);
};
/**
 * Returns the URL path segment based on the blog content type.
 *
 * @param type - The type of the blog content.
 * @returns The URL path segment for the given blog content type.
 */ const getContentPath = (type)=>{
    switch(type){
        case _enums_blogTypeValues__WEBPACK_IMPORTED_MODULE_2__/* .BlogTypeValues.Vlog */ .L.Vlog:
            return "video";
        case _enums_blogTypeValues__WEBPACK_IMPORTED_MODULE_2__/* .BlogTypeValues.Tip */ .L.Tip:
            return "tip";
        case _enums_blogTypeValues__WEBPACK_IMPORTED_MODULE_2__/* .BlogTypeValues.Information */ .L.Information:
            return "info";
        case _enums_blogTypeValues__WEBPACK_IMPORTED_MODULE_2__/* .BlogTypeValues.Blog */ .L.Blog:
        default:
            return "verhaal";
    }
};
/**
 * Returns the base url of the application based on the environment.
 *
 * @returns The base url of the application.
 */ const getBaseUrl = ()=> false ? 0 : "https://www.villapinedo.nl";
/**
 * Determines the target attribute for a given URL.
 * @param url - The URL to evaluate.
 * @returns "_self" for internal links, "_blank" for external links.
 */ const determineTargetAttribute = (url)=>/^[/#]/.test(url) ? "_self" : "_blank";
/**
 * Checks if the current environment is set to production.
 *
 * @returns A boolean indicating whether the environment is production.
 */ const isProduction = ()=>{
    return process.env.ENVIRONMENT == "production";
};


/***/ })

}]);